export const generateComplianceTemplate = `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
    <div class="compliance-container">
        <h2 class="pdf-table-heading">Compliance</h2>
        <div class="compliance-grid-vertical">
            <div>
                <div class="compliance-label">Compliance Type</div>
                <div class="compliance-value">{{complianceType}}</div>
            </div>
            <div>
                <div class="compliance-label">Comments</div>
                <div class="compliance-value">{{{complianceTypeComment}}}</div>
            </div>
        </div>
    </div>
</body>
</html>
`;